var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cog-choice" },
    [
      _c("c-select", {
        ref: "select",
        attrs: {
          id: _vm.id,
          options: _vm.options,
          readonly: _vm.readonly,
          placeholder: _vm.placeholder,
          "allow-other": false,
          filterable: true,
          "filter-match": "beginning",
          chameleon: _vm.chameleon,
          mobile: _vm.mobile,
          scope: _vm.scope
        },
        on: { change: _vm.handleChange },
        model: {
          value: _vm.internalValue,
          callback: function($$v) {
            _vm.internalValue = $$v
          },
          expression: "internalValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }